// removed by extract-text-webpack-plugin
module.exports = {"container":"style__container___1LXGN","title":"style__title___3SMhS","content":"style__content___GDkle","left":"style__left___3DoBY","detail":"style__detail___vY5Y5","prop":"style__prop___3FYFP"};


//////////////////
// WEBPACK FOOTER
// ./src/views/RegionInfoView/style.less
// module id = 298
// module chunks = 0